import { Button, ButtonGroup, Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { CardLayout, LabelAbove, SaveButtonsContainer } from '../../../components/common';
import ContentConstants from '../../../contentConstants';
import { AudienceSourceType, DistributionType, IHasValidationModel, IReportingUser, ISurveyAdminSummary, UserType } from '../../../models';
import { SurveyStatusType } from '../../../models/SurveyStatusType';
import { ReportingUsers } from '../reporting-setup/ReportingUsers';

export interface IReportingAccessProps extends IHasValidationModel {
	audienceSourceType: AudienceSourceType | undefined;
	distributionType: DistributionType | undefined;
	isClosed?: boolean;
	isLoading: boolean;
	isSavingUsers: boolean;
	isSendingEmail: boolean;
	reportingUsers: IReportingUser[];
	surveyAdminSummary?: ISurveyAdminSummary;
	surveyId: number;
	userType: UserType;
	AddUser: (surveyId: number) => void;
	DeleteUser: (user: IReportingUser) => void;
	MinNChange: (minN: number) => void;
	NotifyUser: (surveyId: number, user: IReportingUser) => void;
	Save: (surveyId: number, reportingUsers: IReportingUser[]) => void;
	UpdateUser: (user: IReportingUser) => void;
}

export class ReportingAccess extends React.PureComponent<IReportingAccessProps> {
	public render() {
		const { AddUser, Save, isSavingUsers, isLoading, reportingUsers, surveyAdminSummary, surveyId } = this.props;

		const readOnly = surveyAdminSummary?.surveyStatus === SurveyStatusType.Cancelled;

		return (
			<>
				<CardLayout
					loading={isLoading}
					title={
						readOnly ? ContentConstants.SURVEY_ADMIN_ACTION_REPORTING_USERS_READONLY : ContentConstants.SURVEY_ADMIN_ACTION_REPORTING_USERS
					}
				>
					{readOnly && <LabelAbove type='input' textIsHtml={true} text={ContentConstants.SURVEY_CANCEL_CONTENT_READONLY} />}
					<ReportingUsers {...this.props} AddUser={() => AddUser(surveyId)} isSurveyAdmin={true} />
					<Divider type='dashed' />
					<SaveButtonsContainer>
						<ButtonGroup type='column'>
							<Button
								id='SaveChangesButton'
								color='primary'
								size='lg'
								disabled={isSavingUsers || readOnly}
								onClick={() => Save(surveyId, reportingUsers)}
							>
								{ContentConstants.BUTTON_SAVE_CHANGES}
							</Button>
						</ButtonGroup>
					</SaveButtonsContainer>
				</CardLayout>
			</>
		);
	}
}
